import Cookies from "js-cookie";
import { browserVersion, osName, browserName, osVersion, deviceType } from "react-device-detect";
import userTimeZoneCountryCode from "../components/userTimeZoneCountryCode";
import { getDeviceId } from "../littleStateMachine/utils";
import { userBrowserLanguageChar2 } from "../components/userBrowserLanguage";
import { useStateMachine } from "little-state-machine";

function checkCookieExists(cookieName: string): boolean {
  return document.cookie.split(";").some((item) => item.trim().startsWith(cookieName + "="));
}

const MainLogin = () => {
  const { getState } = useStateMachine();
  const hasSession = checkCookieExists("SUNSTAR_GUM"); // replace with your cookie name

  const cookie_domain =
    getState().loginPageData && import.meta.env.VITE_PUBLIC_DEV === "true"
      ? getState().loginPageData.cookieDomain || ""
      : import.meta.env.VITE_PUBLIC_SUNSTAR_GUM_COOKIE_DOMAIN;
  const countryCode = userTimeZoneCountryCode();
  const browser_language = userBrowserLanguageChar2();
  const device_id = getDeviceId();

  return (
    <div className="font-inter-24 flex flex-col items-center justify-center h-screen bg-gray-100 dark:bg-gray-900 dark:text-white">
      <h1>Main Login Screen</h1>
      <h3>VITE_PUBLIC_DEV: {import.meta.env.VITE_PUBLIC_DEV}</h3>
      {hasSession ? (
        <>
          <p>Session cookie exists!</p>

          <button
            onClick={() => {
              // Clear the session cookie
              Cookies.remove(import.meta.env.VITE_PUBLIC_SUNSTAR_GUM_COOKIE_NAME!, {
                path: "/",
                domain: cookie_domain || import.meta.env.VITE_PUBLIC_SUNSTAR_GUM_COOKIE_DOMAIN!,
              });
              window.location.reload();
            }}
            className="cursor-pointer items-center justify-center gap-x-2 font-semibold disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200 ease-in-out bg-white text-gray-900 shadow-sm shadow-gray-500/5 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 py-0 px-5 h-11 rounded-md inline-flex"
          >
            Sign Out
          </button>
        </>
      ) : (
        <>
          <p>No session cookie found.</p>

          <a
            href="/auth/login"
            className="cursor-pointer items-center justify-center gap-x-2 font-semibold disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200 ease-in-out bg-white text-gray-900 shadow-sm shadow-gray-500/5 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 py-0 px-5 h-11 rounded-md inline-flex mb-2"
          >
            Login
          </a>
          {import.meta.env.VITE_PUBLIC_DEV === "true" && (
            <>
              <a
                href="/auth/login?cookie_domain=localhost"
                className="cursor-pointer items-center justify-center gap-x-2 font-semibold disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200 ease-in-out bg-white text-gray-900 shadow-sm shadow-gray-500/5 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 py-0 px-5 h-11 rounded-md inline-flex mb-2"
              >
                Custom domain Login
              </a>
              <a
                href="/auth/login?redirect_url=https%3A%2F%2Fwww.sunstargum.com%2Fgb-en%2Flegal%2Fprivacy-policy.html&cookie_domain=localhost"
                className="cursor-pointer items-center justify-center gap-x-2 font-semibold disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200 ease-in-out bg-white text-gray-900 shadow-sm shadow-gray-500/5 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 py-0 px-5 h-11 rounded-md inline-flex mb-2"
              >
                Policy redirect Custom domain Login
              </a>

              <a
                href={`/auth/login?redirect_url=${import.meta.env.VITE_PUBLIC_UNITY_DEEPLINK_PREFIX_GUMPLAYBRUSH}://target?login`}
                className="cursor-pointer items-center justify-center gap-x-2 font-semibold disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200 ease-in-out bg-white text-gray-900 shadow-sm shadow-gray-500/5 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 py-0 px-5 h-11 rounded-md inline-flex mb-2"
              >
                Deeplink redirect GUM Playbrush app Login
              </a>
              <a
                href={`/auth/login?redirect_url=${import.meta.env.VITE_PUBLIC_UNITY_DEEPLINK_PREFIX_GUMSMART}://target?login`}
                className="cursor-pointer items-center justify-center gap-x-2 font-semibold disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200 ease-in-out bg-white text-gray-900 shadow-sm shadow-gray-500/5 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 py-0 px-5 h-11 rounded-md inline-flex mb-2"
              >
                Deeplink redirect GUM Smart app Login
              </a>
            </>
          )}
        </>
      )}
      <div className="mt-4 bg-amber-50 p-4 rounded-[20px]">
        <div className="mt-4 bg-amber-50 p-4 rounded-[20px]">
          <div className="flex flex-col gap-2 text-sm text-gray-700">
            <div className="flex">
              <div className="w-40 font-semibold">Device ID:</div>
              <div>{device_id}</div>
            </div>
            <div className="flex">
              <div className="w-40 font-semibold">Device language:</div>
              <div>{browser_language}</div>
            </div>
            <div className="flex">
              <div className="w-40 font-semibold">Device OS:</div>
              <div>
                {osName} {osVersion}
              </div>
            </div>
            <div className="flex">
              <div className="w-40 font-semibold">Browser Name:</div>
              <div>
                {browserName} {browserVersion}
              </div>
            </div>
            <div className="flex">
              <div className="w-40 font-semibold">Device Type:</div>
              <div>{deviceType}</div>
            </div>
            <div className="flex">
              <div className="w-40 font-semibold">Device Country:</div>
              <div>{countryCode}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainLogin;
